"use client";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="cs">
      <body
        style={{
          margin: 0,
          minHeight: "100dvh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#fbfcfe",
          color: "#2b3a52",
          fontFamily: "system-ui, -apple-system, 'Segoe UI', sans-serif",
          padding: "1.5rem",
        }}
      >
        <div style={{ maxWidth: "32rem" }}>
          <p
            style={{
              margin: 0,
              fontSize: "0.75rem",
              fontWeight: 600,
              letterSpacing: "0.18em",
              textTransform: "uppercase",
              color: "#3b6aa9",
            }}
          >
            Neočekávaná chyba
          </p>
          <h1
            style={{
              margin: "0.75rem 0 0",
              fontFamily: "Georgia, 'Times New Roman', serif",
              fontSize: "2rem",
              lineHeight: 1.15,
              color: "#10203a",
            }}
          >
            Něco se nepovedlo
          </h1>
          <p style={{ marginTop: "1rem", fontSize: "1rem", lineHeight: 1.7 }}>
            Stránku se nepodařilo načíst. Zkuste to prosím znovu, případně se obraťte na naši
            kancelář telefonicky nebo e-mailem.
          </p>
          {error.digest ? (
            <p style={{ marginTop: "0.75rem", fontSize: "0.8rem", color: "#64748b" }}>
              Kód chyby: {error.digest}
            </p>
          ) : null}
          <button
            type="button"
            onClick={reset}
            style={{
              marginTop: "1.5rem",
              padding: "0.75rem 1.25rem",
              borderRadius: "0.5rem",
              border: "none",
              backgroundColor: "#35619c",
              color: "#ffffff",
              fontSize: "0.95rem",
              fontWeight: 500,
              cursor: "pointer",
            }}
          >
            Zkusit znovu
          </button>
        </div>
      </body>
    </html>
  );
}
